export const setLanguge = (language) => ({
    type: "SWITCH_LANGUAGE",
    payload: language
  });
  
